import SvgIcon from "./SvgIcon";

// Shared actuals status icon (matches the day-view OutcomesComponent): a tick
// for completed sets, an info-circle for missed, and nothing for
// planned/unlogged. Icons carry their own color; the tinted rounded backdrop
// comes from the surrounding .wk-status-inline .completed/.missed img CSS.
//
// `status === "completed"`, not a bare truthiness check: "draft" (a tracked
// value entered with auto-complete off, never confirmed) is also a truthy
// status, and must render exactly like an untouched set - nothing - not a
// checkmark.
const StatusIcon = ({ status }) =>
  status === "missed" ? (
    <SvgIcon
      src="/img/new-icons/info-circle.svg"
      classNames={status}
      noFilterOnLight
    />
  ) : status === "completed" ? (
    <SvgIcon
      src="/img/new-icons/tick-square.svg"
      classNames={status}
      noFilterOnLight
    />
  ) : null;

export default StatusIcon;
